import { isPageHidden } from "../../utils/checkHiddenPage";
import { SCREEN } from "../../utils/constants";
import { appointmentChannelId, form, hiddenPages, locations, patientSelected, setPatientSelected, setSurgicalOption } from "../../utils/variables";
import { PATIENTS, loadPatients } from "../actions/patientAction";
import { navigate } from "./movePages";
import { handleBothSurgicalOptionsClick, handleNonSurgicalButtonClick, handleSurgicalButtonClick } from "./surgicalListeners";
import { goToServices } from "./validateDigitsListeners";

export const patientListeners = () => {
    loadPatients();
    const lengthServiceType = Object.keys(form?.service_types).length;
    if (lengthServiceType < 2 && !appointmentChannelId) {
        document.querySelector(".patient__actions .backOneStep__btn")?.classList?.add("hide")
    }

    if (patientSelected) {
        const idPatient = PATIENTS?.find(i => i.value === patientSelected)?.id
        idPatient && selectPatient(idPatient)
    }

    /* on select patient*/
    document
        .querySelectorAll('.patients__container .patient')
        .forEach((i) => {
            i.addEventListener('click', () => {
                const id = parseInt(i.getAttribute('data-patient-id'));
                selectPatient(id);
            });
        });

    document
        .querySelector('.patientContinue__btn')
        .addEventListener('click', patientContinueBtnHandler);

    /* On click enter */
    const screenPhone = document.querySelector('.patients__container');
    if (screenPhone) {
        screenPhone.addEventListener('keydown', handlePressEnter);
    }

    if (appointmentChannelId && locations?.length < 2) {
        document
            .querySelector('.patients__container .backOneStep__btn').classList.add("hide")

    }

};

export function patientContinueBtnHandler() {
    // skip patient selection page
    if (!patientSelected && isPageHidden('patient_page', hiddenPages)) {
        setPatientSelected("all");
    }

    if (appointmentChannelId) {
        const lengthServiceType = Object.keys(form.service_types).length;

        if (isPageHidden('surgical', hiddenPages)) {
            handleBothSurgicalOptionsClick()
            return
        }

        if (lengthServiceType > 1) {
            navigate(SCREEN.SURGICAL);
        } else {
            let service = Object.values(form.service_types)[0];
            if (service === "surgical") {
                handleSurgicalButtonClick()
            } else {
                handleNonSurgicalButtonClick()
            }
        }

    } else {
        goToServices();
    }
}

export function selectPatient(id) {
    const select = PATIENTS?.find(i => i.id === +id)?.value || '';
    removeAllSelectedPatient();

    setPatientSelected(select);

    document
        .querySelector(
            `.patient__checkbox[data-patient-id="${CSS.escape(id)}"]`
        )
        .classList.add('is-selected');

    document
        .querySelector('.patientContinue__btn')
        .classList.remove('disabled');
}

const removeAllSelectedPatient = () => {
    setPatientSelected('');
    document
        .querySelectorAll('.patient__checkbox')
        .forEach((i) => i.classList.remove('is-selected'));

    document.querySelector('.patientContinue__btn').classList.add('disabled');
};


function handlePressEnter(event) {
    event.stopPropagation();
    if (event.key === 'Enter' && !document.querySelector(`.patients__container .patientContinue__btn`).classList.contains('disabled')) {
        document
            .querySelector('.patientContinue__btn')
            .click();
    }
}